(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  // 修改点：暴露到 window
  window.initCustomCursor = () => {
    let cursor = document.querySelector('.product-zoom-cursor');
    if (!cursor) {
      cursor = document.createElement('div');
      cursor.className = 'product-zoom-cursor';
      document.body.appendChild(cursor);
    }

    const zoomTriggers = document.querySelectorAll('.product__media-toggle, .product-media-modal__content');

    const moveCursor = (e) => {
      cursor.style.left = e.clientX - 24 + 'px'; 
      cursor.style.top = e.clientY - 24 + 'px';
    };

    zoomTriggers.forEach(trigger => {
      // 核心：移除旧的监听器，防止多次执行报错或卡顿
      if (trigger._mouseenterHandler) {
          trigger.removeEventListener('mouseenter', trigger._mouseenterHandler);
          trigger.removeEventListener('mouseleave', trigger._mouseleaveHandler);
      }

      trigger._mouseenterHandler = () => {
        cursor.classList.add('active');
        document.addEventListener('mousemove', moveCursor);
      };
      trigger._mouseleaveHandler = () => {
        cursor.classList.remove('active');
        document.removeEventListener('mousemove', moveCursor);
      };

      trigger.addEventListener('mouseenter', trigger._mouseenterHandler);
      trigger.addEventListener('mouseleave', trigger._mouseleaveHandler);
    });
  };

  // 修改点：暴露到 window
  window.initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      // 核心：防重复绑定
      if (el._clickHandler) {
          el.removeEventListener('click', el._clickHandler);
      }
      
      el._clickHandler = (e) => {
        imagesWrapper.classList.toggle('zoom');
      };
      
      el.addEventListener('click', el._clickHandler);
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    window.initZoomImage();
    window.initCustomCursor();
  });

  initProductAccordion();
  window.initZoomImage();
  window.initCustomCursor();
})();